<template>
  <div>
    <div v-if="loader">
      <Loader />
    </div>

    <div v-else class="tw-mx-4 tw-mt-4">
      <div class="card row tw-border-0">
        <div class="tw-flex tw-justify-start tw-items-center mr-2" id="summary-filters">
          <div class="mr-2">
            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
              Date
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :max-date="maxDate"
              :locale-data="{ format: 'dd mmm yyyy' }"
              @update="formateDate"
            >
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
              User 
            </div>
            <multiselect
              v-model="selectedUser"
              class="text-capitalize"
              :options="userListData"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="selectedUser?.length == userListData?.length ? 1 : 100"
              @input="handleUserChange"
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedUser"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value.replaceAll("_", " ") }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
              Actions
            </div>
            <multiselect
              v-model="selectedActions"
              class="text-capitalize"
              :options="actionsListData"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="selectedActions?.length == actionsListData?.length ? 1 : 100"
              @input="handleActionsChange"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedActions"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <button class="btn primarycolor pt-[0px] tw-mt-6" @click="dataAPIs">
            Apply Filters
          </button>
        </div>
      </div>
      <div
        class="card row tw-border-0 w-border-0 summaryContainer tw-mb-0 row tw-z-[10]"
      > 
        <div> 
          <div class="" v-if="viewUserLogsData?.headers.length">
            <table id="summaryTable" class="tw-w-full">
              <thead class="thead-normal">
                <tr>
                  <th
                    :colspan="header.subData"
                    v-for="header in viewUserLogsData.headers"
                    :key="header.key"
                  >
                    {{ header.label }}
                  </th>
                </tr>
               
              </thead>
              <tbody>
                <tr
                  v-for="(row, rowIndex) in viewUserLogsData.data"
                  :key="'|' + rowIndex"
                  class="tw-border tw-border-[#d4d4d4]"
                >
                 <td v-for="head of viewUserLogsData.headers" :key="head.key">
                    <div v-if="head.key=='file_url'">
                        <a
                            :href="row[head.key]"
                            target="_blank"
                            class="tw-text-blue-600 tw-underline"
                            >Download</a
                        >
                    </div>
                    <div v-else>{{ row[head.key] }}</div>
                </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="tw-min-h-[400px]">
            <noData :loaderVariable="isLoading" />
          </div>
        </div>
      </div>
      <!-- net sales breakup graph section  -->
      
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";
import stackChart from "../commonCharts/StackChart.vue";
import noData from "../Components/noData.vue";

export default {
  name: "userLogs",
  components: { Datepicker, Multiselect, Loader, stackChart, noData, },
  data: function () {
    return {
      dateRange: {
        startDate: moment().subtract(15, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      // Loader Section start
      loader: false,
      stackChartLoader: false,
      reviewDetailsLoader: false,
      isLoading: false,
      // Loader Section End
      // filter section,
      viewUserLogsData: {},
      viewReviewDetailsData: {},
      viewRattingOfReviewsStackChartData: {},
      proccedRattingStackChartData: {},
      isRatingDownload: false,
      isReviewDownload: false,
      userListData: {},
      selectedUser: [],
      previousSelectedUser: [],
      actionsListData: [],
      selectedActions: [],
      previousSelectedActions: [],
    };
  },
  mounted() {
    this.$store.dispatch("DemoStore/setTimeStamp", ""); //using for clear the last updated time stamp
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
    this.getFilterData();
  },

  methods: {
    dataAPIs() {
      if ($.fn.DataTable.isDataTable("#summaryTable")) {
        $("#summaryTable").DataTable().destroy();
      }
      this.getUserLogsData();
    },

    formateDate() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.dateRange.endDate = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );
      // this.dataAPIs();
    },

    formatNumber(num) {
      if (isNaN(num)) return num;
      let num1 = Number(num).toFixed(2);
      let num2 = Number(num1).toLocaleString();
      return num2;
    },
    handleUserChange(selected){
      const result = this.commonFunctionsForHandleMultiSelect(
        selected,
        this.selectedUser,
        this.selectedUser,
        this.previousSelectedUser,
        this.userListData
      );
      this.selectedUser = result.selectedKeyData;
      this.previousSelectedUser = result.previousSelectedData;
    },

    handleActionsChange(selected){
      const result = this.commonFunctionsForHandleMultiSelect(
        selected,
        this.selectedActions,
        this.selectedActions,
        this.previousSelectedActions,
        this.actionsListData
      );
      this.selectedActions = result.selectedKeyData;
      this.previousSelectedActions = result.previousSelectedData;
    },

    getFilterData(){
      this.isLoading = true;
      this.viewUserLogsData.headers = [];
      const url = "/api/v2/indian_clients/logsdropdown";
      this.$http
        .get(url)
        .then((response) => {
          this.userListData = response.data.data.user;
          this.userListData.unshift({ key: "all", value: "All" });
          this.selectedUser = [...this.userListData];
          this.previousSelectedUser = [...this.selectedUser];
          this.actionsListData = response.data.data.actions;
          this.actionsListData.unshift({ key: "all", value: "All" });
          this.selectedActions = [...this.actionsListData];
          this.previousSelectedActions = [...this.selectedActions];
          this.dataAPIs();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.isLoading = false;
        });
    },
    getUserLogsData() {
      this.isLoading = true;
      this.viewUserLogsData.headers = [];
      const url = "/api/v2/indian_clients/logstable";
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        name: [],  
        email: this.selectedUser
          .filter((item) => item.key !== "all")
          .map((item) => item.key), 
        actions: this.selectedActions
          .filter((item) => item.key !== "all")
          .map((item) => item.key), 
      };
      this.$http
        .post(url, payload)
        .then((response) => {
          this.viewUserLogsData = response.data.data;
          this.$nextTick(() => {
            this.processTable("#summaryTable");
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.isLoading = false;
        });
    },

    commonFunctionsForHandleMultiSelect(currentSelected, emptyKey, selectedKeyData, previousSelectedData, listData){
         if (!currentSelected.length) {
            emptyKey = [];
          }

          const otherOptions = listData.filter((p) => p.key !== "all");

          const isAllCurrentlySelected = currentSelected.some((opt) => opt.key === "all");
          const wasAllPreviouslySelected = previousSelectedData?.some(
            (opt) => opt.key === "all"
          );

          if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
            selectedKeyData = [...listData];
          } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
            selectedKeyData = [];
          } else {
            const selectedWithoutAll = currentSelected.filter((opt) => opt.key !== "all");
            if (selectedWithoutAll.length === otherOptions.length) {
              selectedKeyData = [...listData];
            } else {
              selectedKeyData = [...selectedWithoutAll];
            }
          }

          previousSelectedData = [...selectedKeyData];
          return {selectedKeyData,previousSelectedData};
    },
    processTable(id) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        ordering: true,
        order: [],
        columnDefs: [
          {
            targets: 0,
            className: "min-width-column",
          },
        ],
        initComplete: function () {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      $(id + "_filter > label").append(
        `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
      );
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.card {
  margin-bottom: 1rem !important;
}

.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}

.tab-label {
  cursor: pointer;
  padding-bottom: 12px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}

.stepper-container {
  padding: 20px;
  font-family: sans-serif;
}

.steps {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.step {
  font-weight: 600;
  color: #999;
}

.step.active {
  color: #065559;
  font-weight: bold;
}

.step-circle.active {
  background-color: #065559;
  color: white;
  padding: 10px;
  border-radius: 50%;
}

.line {
  flex-grow: 1;
  height: 2px;
  background-color: #ccc;
  margin: 0 10px;
}

.input-box {
  width: 100%;
  padding: 10px;
  border: 1px solid #aeaeae;
  border-radius: 5px;
  margin-bottom: 16px;
}

.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.sku-pill {
  border: 1px solid #aeaeae;
  border-radius: 20px;
  padding: 6px 12px;
  background: white;
  cursor: pointer;
}

.button-group {
  text-align: right;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
</style>
<style>
#werehouseDateRange .multiselect__tags {
  border: 1px solid #ccc !important;
  max-height: 20px !important;
}

#werehouseDateRange .reportrange-text {
  height: 34px !important;
  width: 180px !important;
}

#werehouseDateRange .reportrange-text span {
  font-size: 16px !important;
}

.borderBetweenTab {
  border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
  margin-bottom: 15px !important;
}
#summary-filters .multiselect__strong {
  display: none !important;
}
</style>
